import { createNode } from '@glueapp/graph-types';

export const BooleanPrimitive = createNode({
    id: 'Boolean',
    name: 'Boolean (True or False)',
    description: 'A Node for holding a boolean, a value that is either true or false',
    aiDescription:
        'A primitive value node that holds a boolean. Set a default value (true or false) on the "Input" port; the "Boolean" output port passes it through.',
    category: 'Logic',
    color: '#cd6205',
    integration: undefined,
    inPorts: {
        Input: { kind: 'boolean' },
    },
    outPorts: {
        Boolean: { kind: 'boolean' },
    },
    execute: function (input) {
        return { output: { Boolean: input.inPorts.Input } };
    },
});
